

import styles from './Toggle.scss';

const Toggle = ({onToggle, isChecked}) => {
    return (
        <label className={styles.switch} data-cy="Tabs-label">
            <input name="billable" type="checkbox" checked={isChecked} 
                onChange={onToggle} data-cy="Tabs-checkbox"/>
            <span className={styles.slider}></span>
        </label>
    );
};

export default Toggle;